import React from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

const Footer = () => {
  const Desktop = useMediaQuery("(max-width:780px)");

  return (
    <div className="Footer">
      <div className="footer-wrapper">
        <div className="upperbox">
          <div className="left">
            <Link to="/">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="96"
                height="119"
                viewBox="0 0 96 119"
                fill="none">
                <path
                  d="M92.4849 117.182C92.4849 116.966 92.564 116.779 92.7221 116.621C92.8802 116.463 93.0691 116.384 93.2889 116.384C93.5087 116.384 93.6976 116.463 93.8557 116.621C94.0138 116.779 94.0929 116.968 94.0929 117.188C94.0929 117.411 94.0138 117.602 93.8557 117.76C93.7015 117.914 93.5126 117.991 93.2889 117.991C93.0614 117.991 92.8705 117.914 92.7163 117.76C92.5621 117.606 92.4849 117.413 92.4849 117.182ZM92.6353 115.84V108.899H93.9425V115.84H92.6353Z"
                  fill="black"
                />
                <path
                  d="M85.2922 110.166H81.712V112.312H85.1881V113.578H81.712V116.563H85.2922V117.83H80.3643V108.899H85.2922V110.166Z"
                  fill="black"
                />
                <path
                  d="M70.9215 114.024L73.6862 117.83H72.0378L69.4871 114.174H69.2441V117.83H67.8965V108.899H69.4755C70.6554 108.899 71.5076 109.121 72.032 109.564C72.6104 110.058 72.8996 110.71 72.8996 111.519C72.8996 112.152 72.7183 112.695 72.3559 113.15C71.9934 113.605 71.5153 113.896 70.9215 114.024ZM69.2441 113H69.6721C70.9485 113 71.5866 112.512 71.5866 111.537C71.5866 110.623 70.9658 110.166 69.7242 110.166H69.2441V113Z"
                  fill="black"
                />
                <path
                  d="M59.0319 115.661H55.2088L54.2139 117.83H52.7622L57.1811 108.338L61.4438 117.83H59.9689L59.0319 115.661ZM58.4825 114.394L57.1579 111.357L55.7698 114.394H58.4825Z"
                  fill="black"
                />
                <path
                  d="M46.5305 109.379V110.976C45.7516 110.324 44.9457 109.998 44.1128 109.998C43.1951 109.998 42.422 110.328 41.7935 110.987C41.1611 111.643 40.8449 112.445 40.8449 113.393C40.8449 114.33 41.1611 115.121 41.7935 115.765C42.4258 116.409 43.2009 116.731 44.1186 116.731C44.5929 116.731 44.9958 116.654 45.3274 116.499C45.5125 116.422 45.7034 116.318 45.9 116.187C46.1006 116.056 46.3107 115.898 46.5305 115.713V117.338C45.7593 117.774 44.9496 117.992 44.1012 117.992C42.8249 117.992 41.7356 117.546 40.8333 116.655C39.9349 115.757 39.4857 114.673 39.4857 113.405C39.4857 112.267 39.8616 111.253 40.6135 110.363C41.539 109.271 42.7362 108.726 44.2054 108.726C45.0074 108.726 45.7824 108.944 46.5305 109.379Z"
                  fill="black"
                />
                <path
                  d="M23.8448 110.166H20.2646V112.312H23.7407V113.578H20.2646V116.563H23.8448V117.83H18.9169V108.899H23.8448V110.166Z"
                  fill="black"
                />
                <path
                  d="M1.46333 108.899L3.78847 114.868L6.21771 108.465L8.54285 114.868L11.0126 108.899H12.4759L8.48501 118.396L6.18879 112.069L3.79425 118.402L0 108.899H1.46333Z"
                  fill="black"
                />
                <path
                  d="M88.6335 96.2726L84.3416 90.1546H87.9936L90.1786 93.3697L92.348 90.1546H96L91.6925 96.2726V101.922H88.6335V96.2726Z"
                  fill="#003DA6"
                />
                <path
                  d="M83.8578 94.0876C83.1503 93.224 82.2763 92.7922 81.2358 92.7922C80.778 92.7922 80.3514 92.8754 79.9561 93.0419C79.5711 93.2084 79.2381 93.4373 78.9572 93.7286C78.6763 94.0095 78.4526 94.3477 78.2861 94.7431C78.13 95.1385 78.052 95.565 78.052 96.0229C78.052 96.4911 78.13 96.9229 78.2861 97.3182C78.4526 97.7136 78.6763 98.057 78.9572 98.3483C79.2485 98.6396 79.5867 98.8685 79.9717 99.035C80.3567 99.2015 80.7728 99.2847 81.2202 99.2847C82.1983 99.2847 83.0775 98.8685 83.8578 98.0362V101.657L83.5457 101.766C83.0775 101.933 82.6405 102.052 82.2347 102.125C81.8289 102.208 81.4283 102.25 81.033 102.25C80.2214 102.25 79.441 102.099 78.6919 101.797C77.9532 101.485 77.2977 101.054 76.7254 100.502C76.1636 99.9402 75.711 99.2795 75.3676 98.52C75.0242 97.75 74.8526 96.9125 74.8526 96.0072C74.8526 95.102 75.019 94.2749 75.352 93.5257C75.6954 92.7662 76.1479 92.1159 76.7098 91.5749C77.2821 91.0234 77.9428 90.5968 78.6919 90.2951C79.441 89.9829 80.2266 89.8269 81.0486 89.8269C81.5168 89.8269 81.9746 89.8789 82.422 89.9829C82.8798 90.0766 83.3584 90.2274 83.8578 90.4355V94.0876Z"
                  fill="#003DA6"
                />
                <path
                  d="M69.711 97.5524L68.3376 93.635L66.9642 97.5524H69.711ZM70.5226 99.8778H66.1526L65.4503 101.922H62.1884L66.6676 90.1546H70.0075L74.4868 101.922H71.2249L70.5226 99.8778Z"
                  fill="#003DA6"
                />
                <path
                  d="M46.6258 101.922L48.6235 90.1546H51.6512L54.0079 96.4287L56.3489 90.1546H59.3767L61.3744 101.922H58.331L57.3166 95.1489L54.5385 101.922H53.3212L50.6836 95.1489L49.6691 101.922H46.6258Z"
                  fill="#003DA6"
                />
                <path
                  d="M39.1502 95.4142H39.7276C40.3311 95.4142 40.7941 95.2893 41.1166 95.0396C41.4392 94.7899 41.6005 94.431 41.6005 93.9627C41.6005 93.4945 41.4392 93.1356 41.1166 92.8859C40.7941 92.6362 40.3311 92.5113 39.7276 92.5113H39.1502V95.4142ZM45.8768 101.922H42.0687L39.1502 97.3963V101.922H36.0912V90.1546H40.8513C41.5068 90.1546 42.0791 90.2535 42.5681 90.4512C43.0571 90.6385 43.4577 90.8986 43.7698 91.2315C44.0924 91.5645 44.3317 91.9494 44.4878 92.3864C44.6542 92.8234 44.7375 93.2916 44.7375 93.7911C44.7375 94.6859 44.519 95.4142 44.082 95.9761C43.6554 96.5275 43.0207 96.9021 42.1779 97.0998L45.8768 101.922Z"
                  fill="#003DA6"
                />
                <path
                  d="M29.9771 97.5524L28.6037 93.635L27.2302 97.5524H29.9771ZM30.7886 99.8778H26.4187L25.7164 101.922H22.4545L26.9337 90.1546H30.2736L34.7528 101.922H31.491L30.7886 99.8778Z"
                  fill="#003DA6"
                />
                <path
                  d="M13.6363 94.6963H18.0531V90.1546H21.1121V101.922H18.0531V97.0686H13.6363V101.922H10.5774V90.1546H13.6363V94.6963Z"
                  fill="#003DA6"
                />
                <path
                  d="M3.05898 95.5547H4.07343C5.19714 95.5547 5.75899 95.0657 5.75899 94.0876C5.75899 93.1096 5.19714 92.6205 4.07343 92.6205H3.05898V95.5547ZM3.05898 101.922H0V90.1546H4.86939C6.19079 90.1546 7.20004 90.498 7.89716 91.1847C8.60468 91.8714 8.95844 92.839 8.95844 94.0876C8.95844 95.3362 8.60468 96.3038 7.89716 96.9905C7.20004 97.6772 6.19079 98.0206 4.86939 98.0206H3.05898V101.922Z"
                  fill="#003DA6"
                />
                <path
                  d="M88.0462 81.1324L86.6728 77.2151L85.2993 81.1324H88.0462ZM88.8577 83.4579H84.4878L83.7855 85.5024H80.5236L85.0028 73.7347H88.3427L92.8219 85.5024H89.5601L88.8577 83.4579Z"
                  fill="#003DA6"
                />
                <path
                  d="M79.189 73.7347V85.5024H76.13V73.7347H79.189Z"
                  fill="#003DA6"
                />
                <path
                  d="M61.9099 85.5024V73.7347H64.9689L70.6186 80.9295V73.7347H73.662V85.5024H70.6186L64.9689 78.3076V85.5024H61.9099Z"
                  fill="#003DA6"
                />
                <path
                  d="M47.6898 85.5024V73.7347H50.7488L56.3985 80.9295V73.7347H59.4419V85.5024H56.3985L50.7488 78.3076V85.5024H47.6898Z"
                  fill="#003DA6"
                />
                <path
                  d="M41.5757 81.1324L40.2023 77.2151L38.8288 81.1324H41.5757ZM42.3872 83.4579H38.0173L37.315 85.5024H34.0531L38.5323 73.7347H41.8722L46.3514 85.5024H43.0896L42.3872 83.4579Z"
                  fill="#003DA6"
                />
                <path
                  d="M31.8521 76.3255V85.5024H28.7931V76.3255H26.2804V73.7347H34.3648V76.3255H31.8521Z"
                  fill="#003DA6"
                />
                <path
                  d="M24.9302 73.7347V85.5024H21.8712V73.7347H24.9302Z"
                  fill="#003DA6"
                />
                <path
                  d="M13.865 78.9943H14.4424C15.0459 78.9943 15.5089 78.8694 15.8315 78.6197C16.154 78.37 16.3153 78.011 16.3153 77.5428C16.3153 77.0746 16.154 76.7156 15.8315 76.4659C15.5089 76.2162 15.0459 76.0914 14.4424 76.0914H13.865V78.9943ZM20.5916 85.5024H16.7835L13.865 80.9764V85.5024H10.806V73.7347H15.5661C16.2216 73.7347 16.7939 73.8335 17.2829 74.0312C17.7719 74.2185 18.1725 74.4786 18.4847 74.8116C18.8072 75.1445 19.0465 75.5295 19.2026 75.9665C19.3691 76.4035 19.4523 76.8717 19.4523 77.3711C19.4523 78.2659 19.2338 78.9943 18.7968 79.5561C18.3702 80.1076 17.7355 80.4821 16.8927 80.6798L20.5916 85.5024Z"
                  fill="#003DA6"
                />
                <path
                  d="M3.05898 83.1301H3.73008C4.50003 83.1301 5.05148 83.0313 5.38443 82.8336C5.71738 82.6359 5.88385 82.3186 5.88385 81.8815C5.88385 81.4445 5.71738 81.1272 5.38443 80.9295C5.05148 80.7318 4.50003 80.633 3.73008 80.633H3.05898V83.1301ZM3.05898 78.3544H3.62083C4.57806 78.3544 5.05668 77.9746 5.05668 77.215C5.05668 76.4555 4.57806 76.0757 3.62083 76.0757H3.05898V78.3544ZM0 73.7347H4.55725C5.63934 73.7347 6.46131 73.9948 7.02316 74.515C7.58502 75.0353 7.86594 75.7844 7.86594 76.7624C7.86594 77.3555 7.75669 77.8497 7.5382 78.2451C7.3301 78.6301 7.00756 78.9578 6.57056 79.2284C7.00756 79.3116 7.37692 79.4417 7.67866 79.6185C7.9908 79.785 8.24051 79.9931 8.4278 80.2428C8.62548 80.4925 8.76595 80.7734 8.84919 81.0856C8.93242 81.3977 8.97404 81.7307 8.97404 82.0844C8.97404 82.6359 8.8752 83.1249 8.67751 83.5515C8.49022 83.9781 8.2197 84.3371 7.86594 84.6284C7.52259 84.9197 7.1012 85.1382 6.60177 85.2839C6.10235 85.4295 5.5405 85.5024 4.91621 85.5024H0V73.7347Z"
                  fill="#003DA6"
                />
                <path
                  d="M71.3245 16.7019L59.3092 10.4187L48.5064 26.5126H68.0175L71.3245 16.7019Z"
                  fill="#7B0828"
                />
                <path
                  d="M62.9169 0L78.0549 8.16051L73.4818 16.6439L58.3438 8.48334L62.9169 0Z"
                  fill="#7B0828"
                />
                <path
                  d="M73.2811 27.8354H17.9445L24.1175 64.8734L56.7187 64.8734L46.6325 53.7399L41.9752 58.7279H39.1091L45.0892 52.1691L40.0737 46.63H35.6919V51.177H33.2944V38.6657H42.7744C43.9318 38.8127 46.2467 39.7129 46.2467 42.138C46.2467 45.1694 44.1523 46.4646 43.1877 46.63L46.6325 50.6534L50.7662 46.2441H53.6047L48.1482 52.1691L59.9155 64.8734L67.1081 64.8734L73.2811 27.8354Z"
                  fill="#7B0828"
                />
                <path
                  d="M35.692 44.7009V40.7601H42.1681C42.9397 40.7601 43.8354 41.5042 43.8354 43.0336C43.8354 44.2572 42.7238 44.655 42.1681 44.7009H35.692Z"
                  fill="#7B0828"
                />
              </svg>
            </Link>

            <p>
              Britannia Pharmacy, serving Mississauga since 2002, is your
              trusted local pharmacy dedicated to providing personalized health
              care services.
            </p>
            {/* <div className="social">
              <a href="http://facebook.com" target="_blank">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none">
                  <g clip-path="url(#clip0_71_2845)">
                    <path
                      d="M14 13.9023H16.5L17.5 9.90234H14V7.90234C14 6.87234 14 5.90234 16 5.90234H17.5V2.54234C17.174 2.49934 15.943 2.40234 14.643 2.40234C11.928 2.40234 10 4.05934 10 7.10234V9.90234H7V13.9023H10V22.4023H14V13.9023Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_71_2845">
                      <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.4021)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a href="http://twitter.com" target="_blank">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none">
                  <g clip-path="url(#clip0_71_2848)">
                    <path
                      d="M22.1623 6.05803C21.3989 6.39572 20.5893 6.6175 19.7603 6.71603C20.6341 6.19346 21.288 5.37104 21.6003 4.40203C20.7803 4.89003 19.8813 5.23203 18.9443 5.41703C18.3149 4.74361 17.4807 4.29699 16.5713 4.14661C15.6618 3.99623 14.7282 4.15052 13.9156 4.58548C13.1029 5.02044 12.4567 5.71171 12.0774 6.55182C11.6981 7.39193 11.607 8.33381 11.8183 9.23103C10.1554 9.14768 8.52863 8.71555 7.04358 7.96269C5.55854 7.20983 4.24843 6.15307 3.1983 4.86103C2.82659 5.49948 2.63125 6.22525 2.6323 6.96403C2.6323 8.41403 3.3703 9.69503 4.4923 10.445C3.82831 10.4241 3.17893 10.2448 2.5983 9.92203V9.97403C2.5985 10.9397 2.93267 11.8756 3.54414 12.6231C4.15562 13.3705 5.00678 13.8835 5.9533 14.075C5.33691 14.2421 4.6906 14.2667 4.0633 14.147C4.33016 14.9783 4.8503 15.7052 5.55089 16.2261C6.25147 16.747 7.09743 17.0358 7.9703 17.052C7.10278 17.7334 6.10947 18.237 5.04718 18.5342C3.98488 18.8314 2.87442 18.9163 1.7793 18.784C3.69099 20.0135 5.91639 20.6661 8.1893 20.664C15.8823 20.664 20.0893 14.291 20.0893 8.76403C20.0893 8.58403 20.0843 8.40203 20.0763 8.22403C20.8952 7.63219 21.6019 6.89905 22.1633 6.05903L22.1623 6.05803Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_71_2848">
                      <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.4021)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a href="https://www.instagram.com/" target="_blank">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none">
                  <g clip-path="url(#clip0_71_2851)">
                    <path
                      d="M12 9.40234C11.2044 9.40234 10.4413 9.71841 9.87868 10.281C9.31607 10.8436 9 11.6067 9 12.4023C9 13.198 9.31607 13.9611 9.87868 14.5237C10.4413 15.0863 11.2044 15.4023 12 15.4023C12.7956 15.4023 13.5587 15.0863 14.1213 14.5237C14.6839 13.9611 15 13.198 15 12.4023C15 11.6067 14.6839 10.8436 14.1213 10.281C13.5587 9.71841 12.7956 9.40234 12 9.40234ZM12 7.40234C13.3261 7.40234 14.5979 7.92913 15.5355 8.86681C16.4732 9.80449 17 11.0763 17 12.4023C17 13.7284 16.4732 15.0002 15.5355 15.9379C14.5979 16.8756 13.3261 17.4023 12 17.4023C10.6739 17.4023 9.40215 16.8756 8.46447 15.9379C7.52678 15.0002 7 13.7284 7 12.4023C7 11.0763 7.52678 9.80449 8.46447 8.86681C9.40215 7.92913 10.6739 7.40234 12 7.40234ZM18.5 7.15234C18.5 7.48386 18.3683 7.80181 18.1339 8.03623C17.8995 8.27065 17.5815 8.40234 17.25 8.40234C16.9185 8.40234 16.6005 8.27065 16.3661 8.03623C16.1317 7.80181 16 7.48386 16 7.15234C16 6.82082 16.1317 6.50288 16.3661 6.26846C16.6005 6.03404 16.9185 5.90234 17.25 5.90234C17.5815 5.90234 17.8995 6.03404 18.1339 6.26846C18.3683 6.50288 18.5 6.82082 18.5 7.15234ZM12 4.40234C9.526 4.40234 9.122 4.40934 7.971 4.46034C7.187 4.49734 6.661 4.60234 6.173 4.79234C5.739 4.96034 5.426 5.16134 5.093 5.49534C4.78001 5.79774 4.53935 6.16693 4.389 6.57534C4.199 7.06534 4.094 7.59034 4.058 8.37334C4.006 9.47734 4 9.86334 4 12.4023C4 14.8763 4.007 15.2803 4.058 16.4313C4.095 17.2143 4.2 17.7413 4.389 18.2283C4.559 18.6633 4.759 18.9763 5.091 19.3083C5.428 19.6443 5.741 19.8453 6.171 20.0113C6.665 20.2023 7.191 20.3083 7.971 20.3443C9.075 20.3963 9.461 20.4023 12 20.4023C14.474 20.4023 14.878 20.3953 16.029 20.3443C16.811 20.3073 17.338 20.2023 17.826 20.0133C18.259 19.8443 18.574 19.6433 18.906 19.3113C19.243 18.9743 19.444 18.6613 19.61 18.2313C19.8 17.7383 19.906 17.2113 19.942 16.4313C19.994 15.3273 20 14.9413 20 12.4023C20 9.92834 19.993 9.52434 19.942 8.37334C19.905 7.59134 19.8 7.06334 19.61 6.57534C19.4593 6.16735 19.2191 5.7983 18.907 5.49534C18.6047 5.18219 18.2355 4.94151 17.827 4.79134C17.337 4.60134 16.811 4.49634 16.029 4.46034C14.925 4.40834 14.539 4.40234 12 4.40234ZM12 2.40234C14.717 2.40234 15.056 2.41234 16.122 2.46234C17.187 2.51234 17.912 2.67934 18.55 2.92734C19.21 3.18134 19.766 3.52534 20.322 4.08034C20.8305 4.58024 21.224 5.18493 21.475 5.85234C21.722 6.48934 21.89 7.21534 21.94 8.28034C21.987 9.34634 22 9.68534 22 12.4023C22 15.1193 21.99 15.4583 21.94 16.5243C21.89 17.5893 21.722 18.3143 21.475 18.9523C21.2247 19.6201 20.8311 20.225 20.322 20.7243C19.822 21.2327 19.2173 21.6261 18.55 21.8773C17.913 22.1243 17.187 22.2923 16.122 22.3423C15.056 22.3893 14.717 22.4023 12 22.4023C9.283 22.4023 8.944 22.3923 7.878 22.3423C6.813 22.2923 6.088 22.1243 5.45 21.8773C4.78233 21.6268 4.17753 21.2333 3.678 20.7243C3.16941 20.2245 2.77593 19.6198 2.525 18.9523C2.277 18.3153 2.11 17.5893 2.06 16.5243C2.013 15.4583 2 15.1193 2 12.4023C2 9.68534 2.01 9.34634 2.06 8.28034C2.11 7.21434 2.277 6.49034 2.525 5.85234C2.77524 5.18452 3.1688 4.57966 3.678 4.08034C4.17767 3.57157 4.78243 3.17807 5.45 2.92734C6.088 2.67934 6.812 2.51234 7.878 2.46234C8.944 2.41534 9.283 2.40234 12 2.40234Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_71_2851">
                      <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.4021)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a href="http://youtube.com" target="_blank">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none">
                  <g clip-path="url(#clip0_71_2854)">
                    <path
                      d="M21.543 6.89986C22 8.68186 22 12.4019 22 12.4019C22 12.4019 22 16.1219 21.543 17.9039C21.289 18.8889 20.546 19.6639 19.605 19.9259C17.896 20.4019 12 20.4019 12 20.4019C12 20.4019 6.107 20.4019 4.395 19.9259C3.45 19.6599 2.708 18.8859 2.457 17.9039C2 16.1219 2 12.4019 2 12.4019C2 12.4019 2 8.68186 2.457 6.89986C2.711 5.91486 3.454 5.13986 4.395 4.87786C6.107 4.40186 12 4.40186 12 4.40186C12 4.40186 17.896 4.40186 19.605 4.87786C20.55 5.14386 21.292 5.91786 21.543 6.89986ZM10 15.9019L16 12.4019L10 8.90185V15.9019Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_71_2854">
                      <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.4021)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div> */}
          </div>
          <div className="right">
            <div className="box">
              <h3 className="head">About</h3>
              <div className="itms">
                <Link className="item" to="/">
                  Home
                </Link>
                <Link className="item" to="/Contact">
                  Contact
                </Link>
              </div>
            </div>
            <div className="box">
              <h3 className="head">Services</h3>
              <div className="itms">
                <Link className="item" to="/MinorAliments">
                  Minor Ailments{" "}
                </Link>
                <Link className="item" to="/services?serviceId=meds-check">
                  Meds Check
                </Link>
                <Link
                  className="item"
                  to="/services?serviceId=compliance-packs">
                  Compliance Packs
                </Link>
                <Link
                  className="item"
                  to="/services?serviceId=Diabete-counseling">
                  Diabetes Counseling
                </Link>
                <Link
                  className="item"
                  to="/services?serviceId=bloodpressure-diabetesmonitoring">
                  Free Blood Pressure & <br /> Diabetes Monitoring
                </Link>
              </div>
            </div>
            <div className="box">
              <h3 className="head">Prescription</h3>
              <div className="itms">
                <Link className="item" to="/Prescription?tab=1">
                  Fill Prescription Online 
                </Link>
                <Link className="item" to="/Prescription?tab=2">
                  Prescription Refill
                </Link>
                <Link className="item" to="/Prescription?tab=3">
                  Prescription Transfer
                </Link>
              </div>
            </div>
            <div className="box">
              <h3 className="head">Policies</h3>
              <div className="itms">
                <Link className="item" to="/Privacy_policy">
                  Privacy Policy
                </Link>
                <Link className="item" to="/Terms">
                  Terms of Use
                </Link>
                <Link className="item" to="/Returning_policy">
                  Returning Policy
                </Link>
              </div>
            </div>
            <div className="box">
              <h3 className="head">Contact Us</h3>
              <div className="itms">
                <a className="item" href="tel:+905-286-4830">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none">
                    <path
                      d="M2.82353 1.25H6.47059L8.29412 5.80882L6.01471 7.17647C6.99117 9.1564 8.5936 10.7588 10.5735 11.7353L11.9412 9.45588L16.5 11.2794V14.9265C16.5 15.4101 16.3079 15.8739 15.9659 16.2159C15.6239 16.5579 15.1601 16.75 14.6765 16.75C11.1199 16.5339 7.76543 15.0236 5.24593 12.5041C2.72643 9.98457 1.21613 6.63008 1 3.07353C1 2.5899 1.19212 2.12608 1.5341 1.7841C1.87608 1.44212 2.3399 1.25 2.82353 1.25Z"
                      stroke="#6F6F6F"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>{" "}
                  905-286-4830
                </a>
                <a className="item" href="mailto:britanniapharmacy11@gmail.com">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none">
                    <path
                      d="M2.5 3H12.5C13.1875 3 13.75 3.5625 13.75 4.25V11.75C13.75 12.4375 13.1875 13 12.5 13H2.5C1.8125 13 1.25 12.4375 1.25 11.75V4.25C1.25 3.5625 1.8125 3 2.5 3Z"
                      stroke="#6F6F6F"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.75 4.25L7.5 8.625L1.25 4.25"
                      stroke="#6F6F6F"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>{" "}
                  britanniapharmacy11
                </a>
                <a
                  className="item"
                  href="https://maps.app.goo.gl/xUB89RM6ChyeUpwF6"
                  target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none">
                    <path
                      d="M13.125 6.25C13.125 10.625 7.5 14.375 7.5 14.375C7.5 14.375 1.875 10.625 1.875 6.25C1.875 4.75816 2.46763 3.32742 3.52252 2.27252C4.57742 1.21763 6.00816 0.625 7.5 0.625C8.99184 0.625 10.4226 1.21763 11.4775 2.27252C12.5324 3.32742 13.125 4.75816 13.125 6.25Z"
                      stroke="#6F6F6F"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.5 8.125C8.53553 8.125 9.375 7.28553 9.375 6.25C9.375 5.21447 8.53553 4.375 7.5 4.375C6.46447 4.375 5.625 5.21447 5.625 6.25C5.625 7.28553 6.46447 8.125 7.5 8.125Z"
                      stroke="#6F6F6F"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>{" "}
                  5980 Churchill Meadows Blvd #11, Mississauga, ON L5M 7M5
                </a>
              </div>
            </div>
          </div>
        </div>
        {!Desktop ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1280"
            height="2"
            viewBox="0 0 1280 2"
            fill="none">
            <path d="M0 1.40234H1280" stroke="#7191C9" stroke-dasharray="5 5" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="342"
            height="2"
            viewBox="0 0 342 2"
            fill="none">
            <path d="M0 1.12305H342" stroke="#7191C9" stroke-dasharray="5 5" />
          </svg>
        )}
        <div className="lower">
          <p>© 2023 Britannia. All Rights Reserved. </p>
          <p>
            Designed & Developed by{" "}
            <a
              href="https://www.webelocity.io/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#003DA6" }}>
              Webelocity
            </a>{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
